import { Component, OnInit, OnDestroy, Input, HostBinding } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { HeaderServiceService } from 'src/app/services/header-service/header-service.service';

@Component({
    selector: 'app-privacy',
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.scss'],
    standalone: false
})
export class PrivacyComponent implements OnInit, OnDestroy {
    @Input() mode: 'page' | 'dialog' = 'page';
    public toggleVerzeichnis: Boolean = false;

    @HostBinding('class.dialog-mode')
        get isDialog(): boolean {
        return this.mode === 'dialog';
    }

    constructor(public headerService: HeaderServiceService) {
        document.documentElement.style.setProperty('--scrollStatus', 'auto');
    }

    ngOnInit(): void {
        this.headerService.loadHeaderText('Datenschutzerklärung');
        document.body.scrollTop = 0;
    }
    ngOnDestroy(): void {
        document.documentElement.style.setProperty('--scrollStatus', 'hidden');
    }
}
